import axios from 'axios';

Shopify.functions.updateCart = async function updateCart(lineItemId, quantity) {
  try {
    const response = await axios.post('/cart/update.js', {
      updates: {
        [lineItemId]: quantity,
      },
    });

    const cart = response.data;
    return cart;
  } catch (error) {
    console.error(error);
  }
};

const cartForm = document.getElementById('cart-form');

cartForm?.addEventListener('keydown', (e) => {
  var key = e.charCode || e.keyCode || 0;
  if (key == 13) {
    e.preventDefault();
  }
});

Shopify.functions.updateCartAttributes = async function updateCartAttributes(attributes = {}) {
  try {
    const response = await axios.post('/cart/update.js', {
      attributes: attributes,
    });

    const cart = response.data;
    return cart;
  } catch (error) {
    console.error('Error updating cart attributes:', error);
  }
};